import { HeroStatCard } from 'src/pages/AnalyticsPage/components/HeroStatCard'
import { formatCount } from 'src/pages/AnalyticsPage/components/heroStatHelpers'

import { DAY_LABELS, hourLabel, type HeatmapSummary } from './constants'

export interface BusiestCell {
  dayOfWeek: number
  hour: number
  value: number
}

export interface CoverageStatsProps {
  summary: HeatmapSummary
  busiest: BusiestCell | null
}

/**
 * The KPI row above the grid: off-hours share, off-hours interviews booked
 * (bookings only ever attach to voice agent calls), and the busiest hour.
 */
export const CoverageStats = ({ summary, busiest }: CoverageStatsProps) => {
  const { totalCalls, offHoursCalls } = summary
  const offPct =
    totalCalls > 0 ? Math.round((offHoursCalls / totalCalls) * 100) : 0

  return (
    <div className="grid grid-cols-3 gap-2.5">
      <HeroStatCard
        label="Calls Made Off-Hours"
        value={offPct}
        suffix="%"
        caption={`${formatCount(offHoursCalls)} of ${formatCount(
          totalCalls
        )} calls outside Mon–Fri 9am–5pm`}
      />

      <HeroStatCard
        label="Off-Hours Interviews Booked"
        value={formatCount(summary.offHoursBookings)}
        caption="booked while your team was off"
      />

      <HeroStatCard
        label="Busiest Hour"
        value={
          busiest
            ? `${DAY_LABELS[busiest.dayOfWeek]} ${hourLabel(busiest.hour)}`
            : '—'
        }
        caption={
          busiest
            ? `${formatCount(busiest.value)} ${
                busiest.value === 1 ? 'call' : 'calls'
              }`
            : ''
        }
      />
    </div>
  )
}

export default CoverageStats
